export default "__VITE_ASSET__Db6n5GNm__"